<div id="ManipDraggableContainer" class="position-relative">
  <canvas #canvas class="ManipWindowComponent"></canvas>
  <div #htmlOverlay class="html-overlay">
    <ng-content></ng-content>
  </div>
 </div>